import React, { FC, ChangeEvent } from 'react';
import { FieldAttributes, useFormikContext } from 'formik';
import { Input } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

interface IProps {
  field: FieldAttributes<any>;
}

const useStyles = makeStyles(theme => ({
  inputRoot: {
    fontSize: 'inherit',
    backgroundColor: 'inherit',
    lineHeight: 'inherit',
    borderRadius: 0,
    border: '1px solid transparent',
  },
  inputInput: {
    padding: 0,
  },
  error: {
    borderColor: theme.palette.error.main,
    padding: 8,
  },
}));

const EditableInput: FC<IProps> = ({ field }) => {
  const classes = useStyles();
  const { errors } = useFormikContext();

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    const { value } = event.target;
    field.onChange(event, parseInt(value, 10));
  }

  return (
    <Input
      required
      error={!!Object.keys(errors).length}
      classes={{ root: classes.inputRoot, input: classes.inputInput, error: classes.error }}
      {...field}
      onChange={handleChange}
    />
  );
};

export default EditableInput;
